import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { EventAggregator } from "@vp/data-access/application";
import { GlobalAlertNotificationEvent } from "@vp/models";
import { AlertItem, VpAlertConfig } from "@vp/shared/components/alert";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as SystemBannerActions from "../state/system-banner-action";
import { SystemBannerAdapter } from "./system-banner-adapter.service";

@Component({
  selector: "vp-system-banner",
  templateUrl: "./system-banner.component.html",
  styleUrls: ["./system-banner.component.scss"],
  providers: [SystemBannerAdapter],
  standalone: false
})
export class SystemBannerComponent implements OnInit, OnDestroy {
  private readonly systemBannerAdapter = inject(SystemBannerAdapter);
  private readonly eventAggregator = inject(EventAggregator);
  private readonly store = inject(Store);

  alertConfig: VpAlertConfig = {
    positionClass: "inline",
    tapToDismiss: false,
    closeButton: true,
    disableTimeOut: true,
    enableHtml: true
  };

  private readonly destroyed$ = new Subject<void>();

  banners$ = this.systemBannerAdapter.banners$.pipe(takeUntil(this.destroyed$));

  ngOnInit(): void {
    this.eventAggregator
      .on<GlobalAlertNotificationEvent>(GlobalAlertNotificationEvent)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(event => this.store.dispatch(new SystemBannerActions.AddGlobalAlert(event.args)));
  }

  alertDismissed(alertItem: AlertItem) {
    this.systemBannerAdapter.dismissBanner(alertItem);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
